<template>
	<div class="axis-tool-sharpener-list">
		<div class="axis-tool-sharpener-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">5-axis Tool-sharpener</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>

				<ul>
					<li>
						<div class="dot">·</div>
						<div class="ll">Support 5-axis linkage RTCP tool tip control technology;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Support virtual machining simulation to quickly verify machining procedures;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Fast tool clamping technology and automatic correction of eccentricity;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Grinding wheel automatic compensation technology;</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">
							Automatic tool setting system and oil cooling system improve sharpening accuracy;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">
							Abundant tool database, supporting 20 kinds of commonly used tools such as two-edged and three-edged twist drills, two-edged, three-edged, four-edged end mills, three-edged, four-edged ball cutters, and chamfer cutters;
						</div>
					</li>
					<li>
						<div class="dot">·</div>
						<div class="ll">Range  of Sharpening tool size ：diameter 3mm~20mm，length 45~250mm.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_precision_02.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.ll {
		width: calc(100% - .625rem);
		margin-bottom: 1.375rem;
	}

	.dot {
		width: .625rem;
	}

	.dot, .ll {
		float: left;
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.list > ul > li {
		width: 100%;
	}

	.list > ul {
		width: 100%;
		height: 21rem;
		border: none;
	}

	.list > img {
		width: 100%;
	}

	.list {
		width: 54.5rem;
		border: none;
		margin-left: 7rem;
	}

	.axis-tool-sharpener-con {
		width: 61.5rem;
		height: 61.5rem;
		border: none;
		margin-left: 0px;
	}

	.axis-tool-sharpener-list {
		width: 100%;
		height: 61.5rem;
		border: none;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 1.375rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-axis-tool-sharpener.vue